import './RoutePages.css';
import React from "react";
import logo from "../../assets/images/logo.png";
import termsOfUse from '../../assets/constants/termsOfUse';
function Terms() {

    return (
        <div className="routePageBackground">
            <div className="routePageBody">
                <div className="routePageHeader"> 
                    <img className="routePageLogoImage" src={logo} alt="cerise logo - interlocking black C's converging in the center into a round, pink dot"/>
                    <h1 className="routePageHeaderText routePageHeaderTextTerms">TERMS </h1>
                </div>
                {termsOfUse}
            </div>
           <a className="backToHomeTerms" href='/' rel="noreferrer"> back to home</a>
        </div>
    )
}

export default Terms;